<form [formGroup]="form" (submit)="onSubmit()">
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Nome Fantasia</mat-label>
      <input
        type="text"
        placeholder="Nome fantasia da sua empresa"
        matInput
        formControlName="businessName"
      />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Razao social</mat-label>
      <input
        type="text"
        placeholder="Razao social"
        matInput
        formControlName="companyName"
      />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Email da empresa (e usuário admin)</mat-label>
      <input
        type="email"
        placeholder="Email de acesso"
        matInput
        formControlName="email"
      />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Telefone</mat-label>
      <input
      matInput
      type="phone"
      placeholder="Informe o número de telefone"
      mask="(00) 00000 0000"
      formControlName="phone"
      inputmode="numeric"
      />
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>CNPJ</mat-label>
      <input
        type="text"
        placeholder="CNPJ da empresa"
        matInput
        formControlName="cnpj"
        mask="00.000.000/0000-00"
        inputmode="numeric"
      />
    </mat-form-field>
    
    <mat-form-field appearance="outline">
      <mat-label>Regime tributário</mat-label>
      <mat-select
        matInput
        aria-placeholder="Regime tributário"
        formControlName="taxRegime"
      >
        <mat-option value="simples_nacional">Simples Nacional</mat-option>
        <mat-option value="lucro_presumido">Lucro Presumido</mat-option>
        <mat-option value="lucro_real">Lucro Real</mat-option>
      </mat-select>
    </mat-form-field>
    
  </div>

  <div class="row">

    <mat-form-field appearance="outline">
      <mat-label>Inscrição estadual (opcional)</mat-label>
      <input
        type="text"
        placeholder="Inscrição estadual"
        matInput
        formControlName="ie"
        inputmode="numeric"
      />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Inscrição municipal (opcional)</mat-label>
      <input
        type="text"
        placeholder="Inscrição municipal"
        matInput
        formControlName="im"
        inputmode="numeric"
      />
    </mat-form-field>

  </div>

  <fieldset>
    <legend>Endereço da empresa</legend>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Cep da empresa</mat-label>
        <input
          type="text"
          matInput
          placeholder="Informe o cep da empresa"
          formControlName="zipCode"
          mask="00000-000"
          inputmode="numeric"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Estado</mat-label>
        <mat-autocomplete
          #autoState="matAutocomplete"
          [displayWith]="displayState"
          (optionSelected)="onStateSelected($event)"
        >
          <ng-container *ngFor="let state of filteredStates$ | async">
            <mat-option [value]="state">{{ state.nome }}</mat-option>
          </ng-container>
        </mat-autocomplete>
        <input
          matInput
          type="text"
          placeholder="Informe o estado"
          formControlName="state"
          [matAutocomplete]="autoState"
        />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Cidade</mat-label>
        <mat-autocomplete #autoCity="matAutocomplete">
          <ng-container *ngFor="let city of filteredCities$ | async">
            <mat-option [value]="city.name">{{ city.name }}</mat-option>
          </ng-container>
        </mat-autocomplete>
        <input
          matInput
          type="text"
          placeholder="Informe a cidade"
          formControlName="city"
          [matAutocomplete]="autoCity"
        />
        <mat-hint>Escolha o estado para mostrar as cidades</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Bairro</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe seu bairro"
          formControlName="district"
        />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Rua/avenida</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe a rua/avenida"
          formControlName="street"
        />
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Numero</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe numero"
          formControlName="number"
          inputmode="numeric"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Complemento</mat-label>
        <input
          matInput
          type="text"
          placeholder="Informe o complemento"
          formControlName="complement"
        />
      </mat-form-field>
    </div>
  </fieldset>

  <div class="actions">
    <button
      mat-raised-button
      class="custom-primary"
      color="primary"
      type="submit"
      matStepperNext
    >
      Continuar
    </button>
  </div>
</form>

<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>
